const formatNumeric = (value, defaultValue) => ((value === undefined || value === 0) ? defaultValue || '-' : value?.toLocaleString());
const formatPercentage = (value, defaultValue) => ((value === undefined || value === 0) ? defaultValue || '% 0.00' : '% '+ (value * 100)?.toLocaleString());

export {
  formatNumeric,
  formatPercentage,
};
